import { render, staticRenderFns } from "./base-text-divider.vue?vue&type=template&id=24d8a759&scoped=true&"
import script from "./base-text-divider.vue?vue&type=script&lang=js&"
export * from "./base-text-divider.vue?vue&type=script&lang=js&"
import style0 from "./base-text-divider.vue?vue&type=style&index=0&id=24d8a759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8a759",
  null
  
)

export default component.exports